// Libs
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// Global Context
import { useUser } from "../context/UserContext";
// Hooks
import useMemberRedirect from "../hooks/useMemberRedirect";
// Material-UI
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

export default function ClassPriceList() {
  const navigate = useNavigate();
  const { user, isUserLoading } = useUser();

  // Redirect user if not a member user
  useMemberRedirect(user, isUserLoading);

  const services = [
    { name: "Little Devils 3-6yrs", price: "£6" },
    { name: "Junior Devils 7-13yrs", price: "£7" },
    { name: "5-15yrs Sparring", price: "£7" },
    { name: "Senior Devils 13+", price: "£7" },
    { name: "Senior Sparring", price: "£7" },
    { name: "Train & Spar (All Ages)", price: "£9.00" },
    { name: "Open Gym", price: "£7" },
    { name: "Morning Kickboxing", price: "£7" },
    { name: "Seniors Boxing", price: "£7" },
  ];

  return (
    <>
      <Helmet>
        <title>{`${user?.club_name || ""} | Price List`}</title>
      </Helmet>
      <Container
        component="main"
        maxWidth="sm"
        sx={{ overflow: "auto", paddingBottom: "100px", pt: "64px" }}
      >
        <TableContainer
          component={Paper}
          sx={{ maxWidth: 650, margin: "auto", marginTop: 5 }}
        >
          <Typography sx={{ textAlign: "center", m: 2 }}>
            1st April 2024 onwards
          </Typography>
          <Typography sx={{ textAlign: "center", m: 2 }}>
            Payment is required on the day of the class. Alternatively, you may
            discuss setting up a monthly standing order with Rob to take
            advantage of potential savings
          </Typography>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Class Name</TableCell>
                <TableCell align="right">Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {services.map((service) => (
                <TableRow key={service.name}>
                  <TableCell component="th" scope="row">
                    {service.name}
                  </TableCell>
                  <TableCell align="right">{service.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
}
